import React from 'react'
import { IProjectGetAllRPC, IProjectOpenRPC } from '@prisma/studio-types'

import Input from 'components/input/Input'
import Folder from 'assets/icons/folder.svg'
import Search from 'assets/icons/search.svg'

import createError from 'utils/createError'

import styles from './projectList.scss'

interface IProps {}

interface IState {
  projects: IProjectGetAllRPC['response']['payload']['data']
  searchText: string
}

class ProjectList extends React.PureComponent<IProps, IState> {
  state: IState = {
    projects: [],
    searchText: '',
  }

  constructor(props: IProps) {
    super(props)
  }

  async componentDidMount() {
    const { error, data } = await window.transport.request<IProjectGetAllRPC>({
      channel: 'project',
      action: 'getAll',
      payload: {
        data: null,
      },
    })

    if (error) {
      return createError(
        'ProjectList.componentDidMount',
        'Failed to fetch all projects',
        {
          error,
        }
      )
    }

    this.setState({
      projects: data,
    })
  }

  handleSearch = (value: string) => {
    this.setState({ searchText: value })
  }

  handleOpen(schemaPath: string) {
    window.transport.request<IProjectOpenRPC>({
      channel: 'project',
      action: 'open',
      payload: {
        data: {
          schemaPath,
        },
      },
    })
  }

  render() {
    const { projects, searchText } = this.state
    const projectsToShow = projects.filter(
      p =>
        p.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
        p.schemaPath?.toLowerCase().includes(searchText?.toLowerCase())
    )

    return (
      <>
        <div className={styles.header}>
          <Search />
          <Input
            type="text"
            className={styles.search}
            value=""
            placeholder="Search"
            onChange={this.handleSearch}
          />
        </div>
        <div className={styles.list}>
          {projectsToShow.map(project => {
            return (
              <div
                key={project.schemaPath}
                className={styles.project}
                onClick={() => this.handleOpen(project.schemaPath)}
              >
                <Folder />
                <div className={styles.projectMeta}>
                  <span className={styles.projectName}>{project.name}</span>
                  <span className={styles.projectDir}>
                    {project.schemaPath}
                  </span>
                </div>
              </div>
            )
          })}
        </div>
      </>
    )
  }
}

export default ProjectList
